'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('./compose');

var ADD_QUOTATION_EVENT = 'bc.addQuotation';
var EDIT_QUOTATION_EVENT = 'bc.editQuotation';
var REMOVE_QUOTATION_EVENT = 'bc.removeQuotation';
var ADD_QUOTATION_ACTION = 'v2-add';
var EDIT_QUOTATION_ACTION = 'v2-edit';
var REMOVE_QUOTATION_ACTION = 'v2-remove';
var QUOTATIONS_GTM_CATEGORY = 'v2-quotations';

function composeQuotationEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: QUOTATIONS_GTM_CATEGORY,
    gtmAction: action
  });
}

function composeAddQuotationEvent() {
  return (0, _compose.composeAnalytics)([composeQuotationEvent(ADD_QUOTATION_EVENT, ADD_QUOTATION_ACTION)]);
}

function composeEditQuotationEvent() {
  return (0, _compose.composeAnalytics)([composeQuotationEvent(EDIT_QUOTATION_EVENT, EDIT_QUOTATION_ACTION)]);
}

function composeRemoveQuotationEvent() {
  return (0, _compose.composeAnalytics)([composeQuotationEvent(REMOVE_QUOTATION_EVENT, REMOVE_QUOTATION_ACTION)]);
}

exports.default = {
  composeAddQuotationEvent: composeAddQuotationEvent,
  composeEditQuotationEvent: composeEditQuotationEvent,
  composeRemoveQuotationEvent: composeRemoveQuotationEvent,
  ADD_QUOTATION_EVENT: ADD_QUOTATION_EVENT,
  EDIT_QUOTATION_EVENT: EDIT_QUOTATION_EVENT,
  REMOVE_QUOTATION_EVENT: REMOVE_QUOTATION_EVENT,
  ADD_QUOTATION_ACTION: ADD_QUOTATION_ACTION,
  EDIT_QUOTATION_ACTION: EDIT_QUOTATION_ACTION,
  REMOVE_QUOTATION_ACTION: REMOVE_QUOTATION_ACTION,
  QUOTATIONS_GTM_CATEGORY: QUOTATIONS_GTM_CATEGORY
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/quotationsEventComposer.js
// module id = 555
// module chunks = 0 2 4 6 7 8 9 10